import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import {
  WebChatBotAccountContext,
  WebChatBotAccountContextType,
} from "./WebChatBotAccountContext";

export const useWebChatBotAccount = (): WebChatBotAccountContextType => {
  const context = useContext(WebChatBotAccountContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useWebChatBotAccount",
      "WebChatBotAccountContext"
    );
  }

  return context;
};
